@for (item of modelArray; track item.id) {
@switch (item?.data && item?.type) {
@case ('page') {
<page-view [model]="item" />
}
@case ('category') {
@if (item.data?.pageTemplate === 'giftcards') {
<giftcards-category-view [model]="item" />
} @else {
<category-view [model]="item" />
}
}
@case ('product') {
<product-layout-view [model]="item" />
}
@case ('store') {
<store-view [model]="item" />
}
@default {
<error-404 />
}
}
} @empty {
<error-404 />
}